import $ from 'jquery';
import './caracteristicas.scss';
import '../../js/mobile-tabs';

import '../../js/form-init';
import '../../js/dropdown-menu';
import '../../js/floating-header';
import '../../js/nav-row';
import '../../js/scroll-animation';
import { scrollTo } from '../../js/scroll-to-contact';
import '../../js/lazy-load';
import '../../js/lazy-load-recaptcha';
import '../../js/lottie';
import '../../js/footer-current-year';

import documentText from "../../data/document-text";

$(function setContent() {
  let currentTabHeader = getCurrentTabHeader();
  let currentTabContent = getCurrentTabContent();

  var inTransition = false;

  $('.empty-section').fadeOut('fast', function () {
    initializeContent(currentTabHeader);
    initializeContent(currentTabContent, scrollToSection);
    updateLanguageMenu();
  });

  $(window).on('hashchange', hashChange);
  function hashChange() {
    const tabHash = window.location.hash.split('_')[0];
    switch (tabHash) {
      // Ventajas
      default:
        ventajasChange();
        break;

      case "#funcionalidades":
      case "#functionalities":
      case "#funcionalitats":
        funcionalidadesChange();
        break;

      case "#infraestructura":
      case "#infrastructure":
        infraestructuraChange();
        break;

      case "#api":
        apiChange();
        break;

      case "#imagenes":
      case "#images":
      case "#imatges":
        imagenesChange();
        break;
    }
  }

  function ventajasChange(e) {
    if (inTransition) return;
    inTransition = true;

    updateHeaderContent(".caracteristicas-header__content-ventajas");
    updateTabContent(".ventajas-content");
    updateLanguageMenu();

    inTransition = false;
  }
  function funcionalidadesChange(e) {
    if (inTransition) return;
    inTransition = true;

    updateHeaderContent(".caracteristicas-header__content-funcionalidades");
    updateTabContent(".funcionalidades-content");
    updateLanguageMenu();

    inTransition = false;
  }
  function infraestructuraChange(e) {
    if (inTransition) return;
    inTransition = true;

    updateHeaderContent(".caracteristicas-header__content-infraestructura");
    updateTabContent(".infraestructura-content");
    updateLanguageMenu();

    inTransition = false;
  }
  function apiChange(e) {
    if (inTransition) return;
    inTransition = true;

    updateHeaderContent(".caracteristicas-header__content-api");
    updateTabContent(".api-content");
    updateLanguageMenu();

    inTransition = false;
  }
  function imagenesChange(e) {
    if (inTransition) return;
    inTransition = true;

    updateHeaderContent(".caracteristicas-header__content-imagenes");
    updateTabContent(".imagenes-content");
    updateLanguageMenu();

    inTransition = false;
  }

  function getCurrentTabHeader() {
    const tabHash = window.location.hash.split('_')[0];
    switch (tabHash) {
      // Ventajas
      default:
        return ".caracteristicas-header__content-ventajas";

      case "#funcionalidades":
      case "#functionalities":
      case "#funcionalitats":
        return ".caracteristicas-header__content-funcionalidades";

      case "#infraestructura":
      case "#infrastructure":
        return ".caracteristicas-header__content-infraestructura";

      case "#api":
        return ".caracteristicas-header__content-api";

      case "#imagenes":
      case "#images":
      case "#imatges":
        return ".caracteristicas-header__content-imagenes";
    }
  }

  function getCurrentTabContent() {
    const tabHash = window.location.hash.split('_')[0];
    switch (tabHash) {
      // Ventajas
      default:
        return ".ventajas-content";

      case "#funcionalidades":
      case "#functionalities":
      case "#funcionalitats":
        return ".funcionalidades-content";

      case "#infraestructura":
      case "#infrastructure":
        return ".infraestructura-content";

      case "#api":
        return ".api-content";

      case "#imagenes":
      case "#images":
      case "#imatges":
        return ".imagenes-content";
    }
  }

  function initializeContent(current, callback) {
    $(current).fadeIn('fast', callback);
  }

  function updateHeaderContent(next) {
    updateContent(currentTabHeader, next);
    currentTabHeader = next;
  }

  function updateTabContent(next) {
    updateContent(currentTabContent, next, scrollToSection);
    currentTabContent = next;
  }

  function updateLanguageMenu() {
    const tabHash = window.location.hash.split('_')[0];
    switch (tabHash) {
      // Ventajas
      default:
        updateLanguageMenuItem('ventajas-section', 'js-language-menu-catalan', 'ca');
        updateLanguageMenuItem('ventajas-section', 'js-language-menu-spanish', 'es');
        updateLanguageMenuItem('ventajas-section', 'js-language-menu-english', 'en');
        break;

      case "#funcionalidades":
      case "#functionalities":
      case "#funcionalitats":
        updateLanguageMenuItem('funcionalidades-section', 'js-language-menu-catalan', 'ca');
        updateLanguageMenuItem('funcionalidades-section', 'js-language-menu-spanish', 'es');
        updateLanguageMenuItem('funcionalidades-section', 'js-language-menu-english', 'en');
        break;

      case "#infraestructura":
      case "#infrastructure":
        updateLanguageMenuItem('infraestructura-section', 'js-language-menu-catalan', 'ca');
        updateLanguageMenuItem('infraestructura-section', 'js-language-menu-spanish', 'es');
        updateLanguageMenuItem('infraestructura-section', 'js-language-menu-english', 'en');
        break;

      case "#api":
        updateLanguageMenuItem('api-section', 'js-language-menu-catalan', 'ca');
        updateLanguageMenuItem('api-section', 'js-language-menu-spanish', 'es');
        updateLanguageMenuItem('api-section', 'js-language-menu-english', 'en');
        break;

      case "#imagenes":
      case "#images":
      case "#imatges":
        updateLanguageMenuItem('imagenes-section', 'js-language-menu-catalan', 'ca');
        updateLanguageMenuItem('imagenes-section', 'js-language-menu-spanish', 'es');
        updateLanguageMenuItem('imagenes-section', 'js-language-menu-english', 'en');
        break;
    }
  }

  function updateLanguageMenuItem(textKey, className, lang) {
    const elems = document.getElementsByClassName(className);
    [...elems].forEach(elem => {
      // Remove the hash from the href
      elem.href = elem.href.split('#')[0];
      elem.href += '#';
      elem.href += documentText[textKey][lang];
    });

  }

  function scrollToSection() {
    const hashes = window.location.hash.split('_');
    if (hashes.length > 1) {
      const sectionId = hashes[1];
      try {
        const top = $(`#${sectionId}`).offset().top;
        scrollTo(top);
      } catch (error) { }
    }
  }

  function updateContent(current, next, callback) {
    $(current).fadeOut('fast', function () {
      $(next).fadeIn('fast', callback);
    });
  }
}

);

$(function setTabCircleAnimation() {
  const tabCircleContainer = $(".caracteristicas-header__tab-circle-container");
  const circle = tabCircleContainer.find('.caracteristicas-header__tab-circle');
  const leftShadow = tabCircleContainer.find('.left-shadow');
  const rightShadow = tabCircleContainer.find('.right-shadow');

  //set the circle's initial position based on the page hash
  $(window).on('hashchange', initialize);
  initialize();
  function initialize() {
    const tabHash = window.location.hash.split('_')[0];
    switch (tabHash) {
      // Ventajas
      default:
        adjust('', '', '', '', '', '');
        break;

      case "#funcionalidades":
      case "#functionalities":
      case "#funcionalitats":
        adjust(210, 576, 234, 552, 225, 561);
        break;

      case "#infraestructura":
      case "#infrastructure":
        adjust(443, 343, 455, 331, 448, 338);
        break;

      case "#api":
        adjust(615, 171, 631, 155, 627, 159);
        break;

      case "#imagenes":
      case "#images":
      case "#imatges":
        adjust(766, 20, 776, 10, 773, 13);
        break;
    }
  }

  function adjust(esLeftShadowPx, esRightShadowPx, enLeftShadowPx, enRightShadowPx, caLeftShadowPx, caRightShadowPx) {
    const lang = $('html').attr('lang');
    switch (lang) {
      default:
        circle.css('left', esLeftShadowPx);
        leftShadow.width(esLeftShadowPx);
        rightShadow.width(esRightShadowPx);
        break;
      case 'en':
        circle.css('left', enLeftShadowPx);
        leftShadow.width(enLeftShadowPx);
        rightShadow.width(enRightShadowPx);
        break;
      case 'ca':
        circle.css('left', caLeftShadowPx);
        leftShadow.width(caLeftShadowPx);
        rightShadow.width(caRightShadowPx);
        break;
    }
  }
});

$(function () {
  $(window).resize(setExtraShadow);

  const tabCircleContainer = $(".caracteristicas-header__tab-circle-container");
  const extraLeftShadow = $(".extra-left-shadow");
  const extraRightShadow = $(".extra-right-shadow");

  function setExtraShadow() {

    const shadowWidth = tabCircleContainer.offset().left;

    extraLeftShadow.width(shadowWidth);
    extraRightShadow.width(shadowWidth);
  }

  setExtraShadow();
});